// import styled, { css } from 'styled-components';

// export const Form = styled.form`
//   max-width: 450px;
//   width: 100%;
//   margin-top: 20px;
//   section {
//     display: flex;
//     justify-content: space-between;
//     flex-wrap: wrap;
//   }
// `;

// export const Input = styled.input`
//   flex: 0 0 49%;
//   width: 100%;
//   border-radius: 3px;
//   border: none;
//   background: #fff;
//   padding: 10px;
//   font-family: 'Open Sans', san-serif;
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 300;
//   letter-spacing: 0em;

//   ${(props) =>
//     props.isError &&
//     css`
//       border: 1px solid #f73d3a;
//       border-left: 13px solid #f73d3a;
//       background: #ffe0e0;
//     `};
//   @media (max-width: 600px) {
//     flex: 0 0 100%;
//     margin-top: 10px;
//   }
// `;

// export const SubmitBtn = styled.button`
//   font-family: 'Open Sans', san-serif;
//   font-size: 13px;
//   font-style: normal;
//   font-weight: 800;
//   letter-spacing: 0.16em;

//   background: #D41F26;
//   border-radius: 3px;
//   margin-top: 10px;
//   padding: 10px;
//   line-height: 1.4;
//   color: #fff;
//   border: none;
//   width: 100%;
//   @media (max-width: 600px) {
//     letter-spacing: 0.15em;
//   }
//   &:hover {
//     opacity: 0.9;
//   }
// `;


// export const Success = styled.div`
//   display: flex;
//   align-items: center;
//   margin-top: 20px;

//   p {
//     font-size: 20px;
//     color: #fff;
//     padding-left: 10px;
//   }

//   img {
//     width: 15px;
//     height: 16px;
//     -webkit-flex: 0 0 20px;
//     -ms-flex: 0 0 20px;
//     flex: 0 0 20px;
//   }

// `;

import styled, { css } from 'styled-components';

export const Form = styled.form`
  section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const Input = styled.input`
  flex: 0 0 49%;
  height: 55px;
  width: 100%;
  border-radius: 12px;
  border: none;
  background: #fff;
  padding: 0 20px;
  ${(props) =>
    props.isError &&
    css`
      border: 1px solid #f73d3a;
      border-left: 13px solid #f73d3a;
      background: #ffe0e0;
    `};
  @media (max-width: 600px) {
    flex: 0 0 100%;
    margin-top: 20px;
  }
`;

export const SubmitBtn = styled.button`
  background: #111111;
  border-radius: 12px;
  margin-top: 20px;
  padding: 15px 20px;
  line-height: 1.4;
  color: #fff;
  letter-spacing: 0.45em;
  font-weight: 900;
  border: none;
  width: 100%;
  @media (max-width: 600px) {
    letter-spacing: 0.15em;
  }
  &:hover {
    opacity: 0.9;
  }
`;


export const Success = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;

  p {
    font-size: 20px;
    color: #fff;
    padding-left: 10px;
  }

  img {
    width: 15px;
    height: 16px;
    -webkit-flex: 0 0 20px;
    -ms-flex: 0 0 20px;
    flex: 0 0 20px;
  }

`;